import OrdersTable from './PaymentsTable';

export default OrdersTable;